import { useEffect } from "react";
import useLocalStorage from "./useLocalStorage";

function useColorMode() {
    const [colorMode, setColorMode] = useLocalStorage("color-theme", "light");

    useEffect(() => {
        if (typeof document === "undefined") return;

        const className = "dark";
        const bodyClass = document.body.classList;

        colorMode === "dark"
            ? bodyClass.add(className)
            : bodyClass.remove(className);
    }, [colorMode]);

    return [colorMode, setColorMode];
}

export default useColorMode;
